import React from "react";
import APIComponent from "../../components/API";
import { STORE_USERS } from "../../constants";
import core from "../../vendors/core-api";

export default function DisplayStoresText(props) {
  const { user = {} } = props;
  return STORE_USERS.includes(user.iam_role) ? (
    <DisplayStoresTextClass {...props} />
  ) : (
    <></>
  );
}

class DisplayStoresTextClass extends APIComponent {
  constructor(props) {
    super(props);

    this.api = core("pu").get();
  }

  async getData() {
    const { user = {} } = this.props,
      { stores = [] } = user;

    this._isMounted && this.setState({ data_status: "fetching" });
    this.api &&
      this.api
        .post({ url: "/settings/get-stores-text", data: { stores } })
        .then(({ data }) => {
          const { data: responseData } = data;

          this._isMounted &&
            this.setState({
              data: responseData,
              data_status: "fetched",
            });
          this.handleOnDataFetched();

          if (this.use_display_data) {
            this.setDisplayData();
          }
        })
        .catch((error) => {
          this._isMounted &&
            this.setState({ error: error, showSwalError: true });
          this.handleOnDataFetchError();
        });
  }

  render() {
    const { data = [], data_status = "" } = this.state,
      isLoading = data_status !== "fetched";

    return isLoading ? (
      <>Loading...</>
    ) : (
      <>
        {data
          .map((d) => {
            return d.name;
          })
          .join(", ")}
      </>
    );
  }
}
